import React, { Component } from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
//import { formatDate, parseDate } from "react-day-picker/moment";
import dayjs from "dayjs";
import "react-day-picker/lib/style.css";
import "../../Styles/Pages/daterangefilter.scss";

class DateRangeFilter extends Component {
	constructor(props) {
		super(props);
		this.dateRangeRef = React.createRef();
		this.state = {
			from: "",
			to: "",
		};
	}

	handleFromChange = day => {
		this.setState({ from: day }, () => {
			this.props.updateFromDate(dayjs(this.state.from).format("YYYY-MM-DD"));
		});
	};

	handleToChange = day => {
		this.setState({ to: day }, () => {
			this.props.updateToDate(dayjs(this.state.to).format("YYYY-MM-DD"));
		});
	};

	componentDidMount() {
		this.setState({
			from: this.props.from ? new Date(this.props.from) : "",
			to: this.props.to ? new Date(this.props.to) : "",
		});
	}

	captureClick = () => {
		if (this.dateRangeRef.current && this.props.autoScroll) {
			this.dateRangeRef.current.scrollIntoView();
		}
	};

	render() {
		const { from, to } = this.state;
		const modifiers = { start: from, end: to };
		return (
			<div
				className={`daterange-filter ${
					this.props.autoScroll || this.props.position === "relative"
						? "relative-position"
						: ""
				}`}
				style={{
					marginBottom: this.props.withMargin ? "20px" : "0px",
					marginTop: this.props.marginTop || "",
				}}
			>
				<div
					style={{
						height: "0.2px",
						overflow: "hidden",
						top: "-100px",
						position: "absolute",
					}}
					ref={this.dateRangeRef}
				/>
				<div className="daterange-filter-calendar">
					<div className="InputFromTo">
						<div>
							{!this.props.hideLabel && (
								<span className="InputFromTo-header">
									{this.props.fromLabel || "From"}
									{!!this.props.required && (
										<span
											style={{
												color: "#ff0505",
												opacity: "0.7",
												paddingLeft: "1px",
											}}
										>
											*
										</span>
									)}
								</span>
							)}
							<div onClick={() => this.captureClick()}>
								<DayPickerInput
									value={from}
									placeholder="From"
									className="form__input"
									format="ll"
									//formatDate={formatDate}
									//parseDate={parseDate}
									inputProps={{
										readOnly: true,
									}}
									dayPickerProps={{
										selectedDays: [from, { from, to }],
										disabledDays: {
											after: to,
											before: this.props.disableBefore
												? this.props.disableBefore
												: null,
										},

										modifiers,
										numberOfMonths: 1,
										onDayClick: () => this.to.getInput().focus(),
									}}
									onDayChange={this.handleFromChange}
									style={{ width: this.props.width || "" }}
								/>
							</div>
						</div>
						<div>
							{!this.props.hideLabel && (
								<span className="InputFromTo-header">
									{this.props.toLabel === null
										? ""
										: this.props.toLabel || "To"}
									{!!this.props.required && (
										<span
											style={{
												color: "#ff0505",
												opacity: "0.7",
												paddingLeft: "1px",
											}}
										>
											*
										</span>
									)}
								</span>
							)}
							<div onClick={() => this.captureClick()}>
								<DayPickerInput
									ref={el => (this.to = el)}
									value={to}
									placeholder="To"
									className="form__input"
									format="ll"
									//formatDate={formatDate}
									//parseDate={parseDate}
									inputProps={{
										readOnly: true,
									}}
									dayPickerProps={{
										selectedDays: [from, { from, to }],
										disabledDays: {
											before: this.props.disableBefore
												? this.props.disableBefore
												: new Date(dayjs(from).add(0, "day")),
										},
										modifiers,
										numberOfMonths: 1,
									}}
									onDayChange={this.handleToChange}
									style={{ width: this.props.width || "" }}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default DateRangeFilter;
